

export const SERVICE_HOURS = 'constantsServiceHours';

export const GENERIC_ERROR_MESSAGE = 'constantsGenericErrorMessage';

export const PAYOFF_QUOTE_ERRORS = {
  CONTACT_US_TITLE: 'constantsPayoffQuoteContactUsTitle',

  NOT_ELIGIBLE: 'constantsPayoffQuoteNotEligible',

  RETRY_EXHAUSTED: 'constantsPayoffQuoteRetryExhausted',

  LOAN_NOT_ELIGIBLE: 'constantsPayoffQuoteLoanNotEligible',
} as const;

export const AUTOPAY_ERRORS = {
  UNABLE_TO_COMPLETE: 'constantsAutopayErrorsUnableToComplete',

  UNABLE_TO_DELETE_TITLE: 'constantsAutopayDeleteErrorHeader',

  UNABLE_TO_SETUP_TITLE: 'servicesAutopayErrorSetupFailedTitle',

  CUTOFF_TIME_TITLE: 'servicesAutopayErrorCutoffTimeTitle',

  CUTOFF_TIME_MESSAGE: 'constantsCutoffWindowDraftInProcess',

  DELETE_FAILED: 'constantsAutopayDeleteErrorMessage',

  SETUP_FAILED: 'constantsGenericErrorMessage',

  NO_BANK_ACCOUNT: 'helocSelectBankAccountRequired',

  MISSING_INFO: 'constantsAutopayErrorsMissingInfo',

  LOAN_INFO_FAILED: 'constantsAutopayErrorsLoanInfoFailed',

  REQUIRED_INFO_FAILED: 'constantsAutopayErrorsRequiredInfoFailed',

  BACK_TO_MANAGE: 'constantsAutopayErrorsBackToManage',
} as const;

export const PAPERLESS_ERRORS = {
  SERVICE_UNAVAILABLE_TITLE: 'constantsPaperlessServiceUnavailableTitle',

  SAVE_FAILED: 'constantsPaperlessSaveFailed',
} as const;

export const PROFILE_ERRORS = {
  VALIDATION_ERROR_TITLE: 'profileSettingsValidationError',
} as const;

export const ACCOUNT_ERRORS = {
  LOAN_NOT_ELIGIBLE_TITLE: 'accountDetailsLoanNotEligible',
} as const;

export const PAYMENT_ERRORS = {
  UNABLE_TO_COMPLETE_TITLE: 'constantsPaymentUnableToCompleteTitle',

  SYSTEM_CHANGES_IN_PROGRESS: 'constantsPaymentSystemChangesInProgress',

  FORECLOSURE_BLOCKED: 'constantsPaymentForeclosureBlocked',

  TRANSFER_IN_PROGRESS: 'constantsPaymentTransferInProgress',

  BAD_CHECK_BLOCKED: 'constantsPaymentBadCheckBlocked',

  SUBMISSION_FAILED: 'constantsPaymentSubmissionFailed',

  INSUFFICIENT_FUNDS_WARNING: 'constantsPaymentInsufficientFundsWarning',

  BANK_VALIDATION_FAILED: 'constantsPaymentBankValidationFailed',

  DUPLICATE_PAYMENT: 'constantsPaymentDuplicatePayment',

  EDIT_FAILED: 'constantsPaymentEditFailed',

  DELETE_FAILED: 'constantsPaymentDeleteFailed',

  CUTOFF_PASSED: 'constantsPaymentCutoffPassed',

  LOAN_NOT_FOUND: 'constantsPaymentLoanNotFound',

  SESSION_EXPIRED: 'constantsPaymentSessionExpired',

  SERVICE_UNAVAILABLE: 'constantsPaymentServiceUnavailable',
} as const;

export const PAYMENT_INFO = {
  PROCESSING_TIME: 'constantsPaymentInfoProcessingTime',

  CUTOFF_TIME: 'constantsPaymentInfoCutoffTime',

  WEEKEND_HOLIDAY: 'constantsPaymentInfoWeekendHoliday',

  AMOUNT_CHANGE_DISCLAIMER: 'constantsPaymentInfoAmountChangeDisclaimer',
} as const;

export const PAYMENT_SUCCESS = {
  SUBMISSION_CONFIRMED: 'constantsPaymentSuccessSubmissionConfirmed',

  EDIT_CONFIRMED: 'constantsPaymentSuccessEditConfirmed',

  DELETE_CONFIRMED: 'constantsPaymentSuccessDeleteConfirmed',

  CONFIRMATION_EMAIL: 'paymentConfirmationEmailSentTo',
} as const;

export const PAYMENT_PROMPTS = {
  AUTOPAY_SUGGESTION: 'constantsPaymentPromptsAutopaySuggestion',

  SECURE_MESSAGE_HELP: 'constantsPaymentPromptsSecureMessageHelp',
} as const;

export const PAYMENT_STATUS_MESSAGES = {
  ACTIVE_PLAN_BODY: 'constantsPaymentStatusActivePlanBody',

  PREPAID_BANNER_ONE_MONTH: 'constantsPaymentStatusPrepaidBannerOneMonth',
  PREPAID_BANNER_TWO_MONTHS_NO_ESCROW: 'constantsPaymentStatusPrepaidBannerTwoMonthsNoEscrow',
  PREPAID_BANNER_TWO_MONTHS_WITH_ESCROW: 'constantsPaymentStatusPrepaidBannerTwoMonthsWithEscrow',
  PREPAID_NEXT_DUE_DATE: 'paymentStatusBannerNextDueDate',

  ADDITIONAL_PAYMENTS_DISABLED: 'constantsPaymentStatusAdditionalPaymentsDisabled',

  TRIAL_PRINCIPAL_RESTRICTION: 'paymentAmountPrincipalNotAvailable',
  TRIAL_ESCROW_RESTRICTION: 'paymentAmountEscrowNotAvailable',
  TWO_MONTHS_PAID_PRINCIPAL_RESTRICTION: 'constantsPaymentStatusTwoMonthsPaidPrincipalRestriction',
} as const;

export const PAYMENT_VALIDATION_MESSAGES = {
  DATA_NOT_AVAILABLE: 'paymentsMakePaymentErrorDataUnavailable',

  AMOUNT_REQUIRED: 'paymentsMakePaymentErrorAmountZero',

  METHOD_REQUIRED: 'paymentsMakePaymentErrorSelectMethod',

  METHOD_NOT_FOUND: 'paymentsMakePaymentErrorMethodNotFound',

  DEFAULT_FAILED: 'paymentsMakePaymentErrorPaymentFailed',
} as const;
